<template>
	<div class="home">
		<StepBreadcrumb :step="step" @change="view_step"/>

		<ErrorMessage :message="error_message" v-if='error_message !== undefined && error_message.length > 0' />
		<WarningMessage :message="warning_message" v-if='warning_message !== undefined && warning_message.length > 0' />

		<!-- Step 1: Collect Information -->
		<InvoiceStep v-if='step == 1' @success="process_invoice"/>

		<!-- Step 2: Collect Billing Address -->
		<BillingStep v-if='step == 2' @start_over="start_over" @success="process_billing"/>

		<!-- Step 3: Select and/or process payment -->
		<PaymentStep v-if='step == 3' @start_over="start_over" @success="process_payment"/>

		<!-- Step 4: Review entered details -->
		<ReviewStep v-if='step == 4' @start_over="start_over" @success="process_review"/>
	</div>
</template>

<script>
// Store
import store from "@/store";

// Import Major components
import StepBreadcrumb from "@/components/general/StepBreadcrumb";
import InvoiceStep from "@/components/steps/invoice_step/InvoiceStep";
import BillingStep from "@/components/steps/billing_step/BillingStep";
import PaymentStep from "@/components/steps/payment_step/PaymentStep";
import ReviewStep from "@/components/steps/review_step/ReviewStep";

/* Smaller elements */
import WarningMessage from "@/components/messages/WarningMessage";
import ErrorMessage from "@/components/messages/ErrorMessage";

export default {
	name: "Home",
	components: {
		StepBreadcrumb,
		InvoiceStep,
		BillingStep,
		PaymentStep,
		ReviewStep,

		WarningMessage,
		ErrorMessage
	},
	props: {
		// On re-routing, we want to collect optional error messages, etc
		error: {
			type: String
		}
	},
	data() {
		// Our primary data objects (used to store user data and progress)
		return {
			step: 1,
			error_message: "",
			warning_message: ""
		}
	},
	beforeMount(src){
		this.error_message = this.error;
	},
	methods: {
		process_invoice: function(){
			this.view_step(2);
		},
		process_review: function(order_id){
			// Forward user off to the review screen
			this.$router.push({ name: 'Order', params: { orderId: order_id }});
		},
		process_billing: function(){
			this.view_step(3);
		},
		process_payment: function(){
			this.view_step(4);
		},
		view_step: function(step){
			// On screen switch, reset messages
			this.error_message = "";
			this.warning_message = "";
			this.step = step;
		},
		// User wants to reset their process. Wipe it all.
		start_over() {
			sessionStorage.clear();
			location.reload();
		}
	}
};
</script>

<style lang="scss">
	@import "node_modules/bootstrap/scss/functions";
	@import "node_modules/bootstrap/scss/variables";
	@import "node_modules/bootstrap/scss/mixins/_breakpoints";

	.input-block.focus{
		background-color: #F9FDFF;
	}

	.step{
		position: relative;
	}
	a{
		cursor: pointer;
		text-decoration: underline !important;

	}
	.home{
		font-size: 16px;
		font-family: 'proximanova-regular';
		position: relative;
	}

	.start-over {
		display: block;
		width: 100%;
		text-decoration: none !important;
		text-align: center;
		margin-top: 30px;
		margin-bottom: 10px;
		font-size: 18px;

		@include media-breakpoint-up(lg) {
			display: inline-table;
			text-align: left;
			margin-top: 15px;
			margin-bottom: 0;
		}
	}

	.contact-text{
		text-align: center;
		margin: 15px 0;

		.support-link{
			margin-left: 5px;
			font-size: 18px;
			text-decoration: none !important;
		}
	}
	.sub-header{
		padding: 0 0 5px 0;
		margin: 0px;
		font-size: 28px;
		line-height: 34px;
	}
	hr{
		border-top: 2px solid #d5d9de;
		margin: 30px 0px;
		width: 100%;
	}

	.button-box{
		display: inline-block;
		width: 100%;
		margin-top: 50px;
		border-top: 3px solid #E2E3E3;
		padding-top: 50px;
	}

	.submit-button{
		cursor: pointer;
		height: 55px;
		display: block;
		margin: 0 auto;
		text-transform: uppercase;
		font-family: 'proximanova-bold';
		padding: 0 10px;
		border: 2px solid transparent;
		transition: all 0.5s;
		text-align: center;
		border-radius: 7px;
		font-size: 20px;

		@include media-breakpoint-up(lg) {
			float: right;
			display: inline-table;
			margin: initial;
    	}

		&:hover{
			color: #ffffff;
		}
	}

	::placeholder, ::-webkit-input-placeholder{ color: #AAA; }
	:-ms-input-placeholder{ color: #AAA; }
</style>
